/**
 * Utility functions to check for empty/missing required fields in user profiles
 */

/**
 * Check if a student has all required fields filled
 * @param {Object} student - Student object
 * @returns {Object} - { hasEmptyFields: boolean, emptyFields: string[] }
 */
export const checkStudentRequiredFields = (student) => {
  const requiredFields = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'gk_code', label: 'GK Code' },
    { key: 'date_of_birth', label: 'Date of Birth' },
    { key: 'contact_number', label: 'Contact Number' },
    { key: 'full_address', label: 'Address' },
    { key: 'payment_term', label: 'Payment Term' },
    { key: 'student_mode', label: 'Student Mode' },
    { key: 'grade', label: 'Grade' },
    { key: 'center_id', label: 'Center' },
    { key: 'module', label: 'Module' }
  ];

  const emptyFields = requiredFields
    .filter(field => {
      const value = student[field.key];
      return value === null || value === undefined || value === '' || 
             (typeof value === 'string' && value.trim() === '');
    })
    .map(field => field.label);

  return {
    hasEmptyFields: emptyFields.length > 0,
    emptyFields
  };
};

/**
 * Check if a teacher has all required fields filled
 * @param {Object} teacher - Teacher object
 * @returns {Object} - { hasEmptyFields: boolean, emptyFields: string[] }
 */
export const checkTeacherRequiredFields = (teacher) => {
  const requiredFields = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'contact_number', label: 'Contact Number' },
    { key: 'full_address', label: 'Address' },
    { key: 'center_id', label: 'Center' },
    { key: 'date_of_birth', label: 'Date of Birth' }
  ];

  const emptyFields = requiredFields
    .filter(field => {
      const value = teacher[field.key];
      return value === null || value === undefined || value === '' || 
             (typeof value === 'string' && value.trim() === '');
    })
    .map(field => field.label);

  return {
    hasEmptyFields: emptyFields.length > 0,
    emptyFields
  };
};

/**
 * Get tooltip text for empty fields alert
 * @param {string[]} emptyFields - Array of empty field labels
 * @returns {string} - Formatted tooltip text
 */
export const getEmptyFieldsTooltip = (emptyFields) => {
  if (emptyFields.length === 0) return '';
  
  if (emptyFields.length <= 3) {
    return `Missing: ${emptyFields.join(', ')}`;
  }
  
  return `Missing ${emptyFields.length} required fields: ${emptyFields.slice(0, 3).join(', ')}...`;
};
